module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "lost-found-item-container"
  }, [_c('header', {
    staticClass: "lost-found-item-header"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('section', {
    staticClass: "lost-found-item-body"
  }, [_c('div', {
    staticClass: "lost-found-item-body-gallery"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lost-found-images"
  }, _vm._l((_vm.images), function(image) {
    return _c('img', {
      key: image,
      staticClass: "lost-found-image",
      attrs: {
        "src": image,
        "width": "222",
        "height": "123",
        "alt": "Lost Found Gallery"
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "lost-found-item-comment"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.comment) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "lost-found-item-actions"
  }, [(_vm.status === 1) ? _c('button', {
    class: _vm.statusButton.class,
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.onStatusChange
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.statusButton.text) + "\n\t\t\t")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h6', [_vm._v("Fotos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h6', [_vm._v("Comentario")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b889d74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LostFoundItem.vue
// module id = 964
// module chunks = 39 40 41 42 43 44